"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../../shared/helpers/notificationHelper");
var CardRowNumericEditor_1 = require("../../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowSelectEditor_1 = require("../../../../../../../../../shared/components/editors/CardRowSelectEditor");
var TabEditorContainer_1 = require("../../../../../../../../../shared/components/containers/TabEditorContainer");
var PlayerBonusWagerNoDepCfgEdit = /** @class */ (function (_super) {
    __extends(PlayerBonusWagerNoDepCfgEdit, _super);
    function PlayerBonusWagerNoDepCfgEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_restrictions = "restrictions";
        _this.key_freespins = "freespins";
        return _this;
    }
    PlayerBonusWagerNoDepCfgEdit.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_CANCEL = this.props.listBonusCancelTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_cancel_types: data.data
            });
        });
        this.SID_DEBIT = this.props.listBonusDebitTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_debit_types: data.data
            });
        });
        this.SID_PERMISSION = this.props.listBonusPermissionTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_permission_types: data.data
            });
        });
        this.SID_WITHDRAW = this.props.listBonusWithdrawTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_withdraw_types: data.data
            });
        });
        this.SID_GAMESET = this.props.listGameSet.Subscribe("*", function (id, data) {
            _this.setState({
                avail_gamesets: data.data
            });
        });
        this.SID_GAMESET_GAMES = this.props.listGameSetGames.Subscribe("*", function (id, data) {
            _this.setState({
                avail_gameset_games: data.data
            });
        });
        this.SID_LVL_SRCTYPES = this.props.ListBonusLevelSrcTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_level_src: data.data
            });
        });
        this.SID_ZONES = this.props.ListGameProviderZones.Subscribe("*", function (id, data) {
            _this.setState({
                avail_gws_zones: data.data
            });
        });
        if (this.props.record) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    bonus_amount_value: _this.props.data.DATA.bonus_amount_value,
                    bonus_min_balance_to_activate: _this.props.data.DATA.bonus_min_balance_to_activate,
                    is_bonus_req_min_balance_to_activate: _this.props.data.DATA.is_bonus_req_min_balance_to_activate,
                    bonus_wager_multiplier: _this.props.data.DATA.bonus_wager_multiplier,
                    bonus_up_to_withdraw_amount_limit: _this.props.data.DATA.bonus_up_to_withdraw_amount_limit,
                    is_bonus_has_up_to_withdraw_amount_limit: _this.props.data.DATA.is_bonus_has_up_to_withdraw_amount_limit,
                    bonus_up_to_bonus_amount_limit: _this.props.data.DATA.bonus_up_to_bonus_amount_limit,
                    is_bonus_has_up_to_bonus_amount_limit: _this.props.data.DATA.is_bonus_has_up_to_bonus_amount_limit,
                    bonus_up_to_bet_amount_limit: _this.props.data.DATA.bonus_up_to_bet_amount_limit,
                    is_bonus_has_up_to_bet_amount_limit: _this.props.data.DATA.is_bonus_has_up_to_bet_amount_limit,
                    bonus_cancel_type_code: _this.props.data.DATA.bonus_cancel_type_code,
                    bonus_cancel_type_title: _this.props.data.DATA.bonus_cancel_type_title,
                    bonus_debit_type_code: _this.props.data.DATA.bonus_debit_type_code,
                    bonus_debit_type_title: _this.props.data.DATA.bonus_debit_type_title,
                    bonus_permission_type_code: _this.props.data.DATA.bonus_activation_type_code,
                    bonus_permission_type_title: _this.props.data.DATA.bonus_activation_type_title,
                    bonus_withdraw_type_code: _this.props.data.DATA.bonus_withdrawal_type_code,
                    bonus_withdraw_type_title: _this.props.data.DATA.bonus_withdrawal_type_title,
                    avail_bonus_debit_types: [],
                    avail_bonus_cancel_types: [],
                    avail_bonus_withdraw_types: [],
                    avail_bonus_permission_types: [],
                    avail_gamesets: [],
                    avail_gameset_games: [],
                    is_deposit_allowed: _this.props.data.DATA.is_bonus_deposit_allowed,
                    on_deposit_add_bonus_balance_percent: _this.props.data.DATA.on_deposit_add_percent_value_on_bonus_balance,
                    on_deposit_add_bonus_wagering_percent: _this.props.data.DATA.on_deposit_add_percent_value_on_bonus_wagering,
                    is_bonus_auto_complete: _this.props.data.DATA.is_auto_complete_bonus,
                    freespin_gameset_id: _this.props.data.DATA.freespin_gameset_id,
                    freespin_gameset_title: _this.props.data.DATA.freespin_gameset_title,
                    is_freespin_pre_selected_game: _this.props.data.DATA.is_freespin_pre_selected_game,
                    freespin_game_id: _this.props.data.DATA.freespin_game_id,
                    freespin_game_title: _this.props.data.DATA.freespin_game_title,
                    freespin_count: _this.props.data.DATA.freespin_count,
                    is_freespin_pre_selected_bet: _this.props.data.DATA.is_freespin_pre_selected_bet,
                    freespin_bet: _this.props.data.DATA.freespin_bet,
                    is_freespin_pre_selected_denomination: _this.props.data.DATA.is_freespin_pre_selected_denomination,
                    freespin_denomination: _this.props.data.DATA.freespin_denomination,
                    is_freespin_pre_selected_multiplier: _this.props.data.DATA.is_freespin_pre_selected_multiplier,
                    freespin_multiplier: _this.props.data.DATA.freespin_multiplier,
                    avail_level_src: [],
                    is_bonus_get_wager_and_amount_from_level: _this.props.data.DATA.is_bonus_get_wager_and_amount_from_level,
                    bonus_wager_and_amount_level_source_type_code: _this.props.data.DATA.bonus_wager_and_amount_level_source_type_code,
                    bonus_wager_and_amount_level_source_type_title: _this.props.data.DATA.bonus_wager_and_amount_level_source_type_title,
                    is_freespin_pre_selected_lines: _this.props.data.DATA.is_freespin_pre_selected_lines,
                    freespin_lines: _this.props.data.DATA.freespin_lines,
                    is_custom_gws_zone: _this.props.data.DATA.is_custom_gws_zone,
                    custom_gws_zone_id: _this.props.data.DATA.custom_gws_zone_id,
                    custom_gws_zone_title: _this.props.data.DATA.custom_gws_zone_title,
                    is_override_gws_player_zone: _this.props.data.DATA.is_override_gws_player_zone,
                    avail_gws_zones: [],
                    is_active_bonus_has_expiration: _this.props.data.DATA.is_active_bonus_has_expiration,
                    bonus_expiration_action_code: _this.props.data.DATA.bonus_expiration_action_code,
                    bonus_expiration_action_title: _this.props.data.DATA.bonus_expiration_action_title,
                    // bonus_expiration_action_rules: IInputRulesState;
                    active_bonus_expiration_ttl_hours: _this.props.data.DATA.active_bonus_expiration_ttl_hours,
                    tabKey: _this.key_main
                }, function () {
                    _this.LoadTypes(true);
                });
            });
        }
        else {
            this.setState({
                is_bonus_req_min_balance_to_activate: false,
                bonus_amount_value: 100,
                bonus_min_balance_to_activate: 200,
                bonus_wager_multiplier: 30,
                bonus_up_to_withdraw_amount_limit: 10000,
                is_bonus_has_up_to_withdraw_amount_limit: false,
                bonus_up_to_bonus_amount_limit: 10000,
                is_bonus_has_up_to_bonus_amount_limit: false,
                bonus_up_to_bet_amount_limit: 10000,
                is_bonus_has_up_to_bet_amount_limit: false,
                avail_bonus_debit_types: [],
                avail_bonus_cancel_types: [],
                avail_bonus_permission_types: [],
                avail_bonus_withdraw_types: [],
                avail_gamesets: [],
                avail_gameset_games: [],
                bonus_cancel_type_code: 0,
                bonus_cancel_type_title: "",
                bonus_debit_type_code: 0,
                bonus_debit_type_title: "",
                bonus_permission_type_code: 0,
                bonus_permission_type_title: "",
                bonus_withdraw_type_code: 0,
                bonus_withdraw_type_title: "",
                is_deposit_allowed: false,
                on_deposit_add_bonus_balance_percent: 0,
                on_deposit_add_bonus_wagering_percent: 0,
                is_bonus_auto_complete: false,
                freespin_gameset_id: 0,
                freespin_gameset_title: "",
                is_freespin_pre_selected_game: false,
                freespin_game_id: 0,
                freespin_game_title: "",
                freespin_count: 0,
                is_freespin_pre_selected_bet: false,
                freespin_bet: 0.01,
                is_freespin_pre_selected_denomination: false,
                freespin_denomination: 0.01,
                is_freespin_pre_selected_multiplier: false,
                freespin_multiplier: 1,
                avail_level_src: [],
                is_bonus_get_wager_and_amount_from_level: false,
                bonus_wager_and_amount_level_source_type_code: 0,
                bonus_wager_and_amount_level_source_type_title: "",
                is_freespin_pre_selected_lines: false,
                freespin_lines: 0,
                is_custom_gws_zone: false,
                custom_gws_zone_id: 0,
                custom_gws_zone_title: "",
                is_override_gws_player_zone: false,
                avail_gws_zones: [],
                is_active_bonus_has_expiration: false,
                bonus_expiration_action_code: 0,
                bonus_expiration_action_title: "",
                // bonus_expiration_action_rules: IInputRulesState;
                active_bonus_expiration_ttl_hours: 168,
                tabKey: this.key_main
            }, function () {
                _this.LoadTypes(false);
            });
        }
        this.props.state.setExtBreadCrumbPath(["Настройка бездепозитного бонуса"]);
        this.doReSetRules();
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.LoadTypes = function (hasData) {
        this.props.listBonusCancelTypes.LoadData();
        this.props.listBonusDebitTypes.LoadData();
        this.props.listBonusPermissionTypes.LoadData();
        this.props.listBonusWithdrawTypes.LoadData();
        this.props.listGameSet.LoadDataByBrandAndCurrency(this.props.player.brand_id, this.props.player.app_currency_id);
        this.props.ListGameProviderZones.LoadDataByBrandAndCurrency(this.props.player.brand_id, this.props.player.app_currency_id);
        this.props.ListBonusLevelSrcTypesAvail.LoadData();
        if (hasData) {
            if (this.props.record) {
                if (this.props.record.is_freespins) {
                    if (this.state.freespin_gameset_id > 0) {
                        this.props.listGameSetGames.LoadDataByGameSetId(this.state.freespin_gameset_id);
                    }
                }
            }
        }
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.ComponentWillUnmount = function () {
        this.props.listBonusCancelTypes.UnSubscribe(this.SID_CANCEL);
        this.props.listBonusDebitTypes.UnSubscribe(this.SID_DEBIT);
        this.props.listBonusPermissionTypes.UnSubscribe(this.SID_PERMISSION);
        this.props.listBonusWithdrawTypes.UnSubscribe(this.SID_WITHDRAW);
        this.props.listGameSet.UnSubscribe(this.SID_GAMESET);
        this.props.listGameSetGames.UnSubscribe(this.SID_GAMESET_GAMES);
        this.props.ListBonusLevelSrcTypesAvail.UnSubscribe(this.SID_LVL_SRCTYPES);
        this.props.ListGameProviderZones.UnSubscribe(this.SID_ZONES);
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.doReSetRules = function () {
        this.setState({
            bonus_debit_type_rules: { isError: false },
            bonus_cancel_type_rules: { isError: false },
            on_deposit_add_bonus_balance_percent_rules: { isError: false },
            on_deposit_add_bonus_wagering_percent_rules: { isError: false },
            freespin_gameset_rules: { isError: false },
            freespin_game_rules: { isError: false },
            freespin_count_rules: { isError: false },
            freespin_bet_rules: { isError: false },
            freespin_denomination_rules: { isError: false },
            freespin_multiplier_rules: { isError: false },
            bonus_wager_and_amount_level_source_type_rules: { isError: false },
            freespin_lines_rules: { isError: false },
            custom_gws_zone_rules: { isError: false },
            bonus_expiration_action_rules: { isError: false }
        });
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.bonus_debit_type_code) || (this.state.bonus_debit_type_title.length === 0)) {
            this.setState({
                bonus_debit_type_rules: { isError: true, errorMessage: "Поле [Списание ставки] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.is_deposit_allowed) {
            if ((this.state.on_deposit_add_bonus_balance_percent < 0) || (this.state.on_deposit_add_bonus_balance_percent > 1000)) {
                this.setState({
                    on_deposit_add_bonus_balance_percent_rules: { isError: true, errorMessage: "Некорректное значение % зачисления на бонусный баланс!" },
                    tabKey: this.key_additional
                });
                return false;
            }
            if ((this.state.on_deposit_add_bonus_wagering_percent < 0) || (this.state.on_deposit_add_bonus_wagering_percent > 1000)) {
                this.setState({
                    on_deposit_add_bonus_wagering_percent_rules: { isError: true, errorMessage: "Некорректное значение % зачисления в отыгрыш!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if ((!this.state.bonus_cancel_type_code) || (this.state.bonus_cancel_type_title.length === 0)) {
            this.setState({
                bonus_cancel_type_rules: { isError: true, errorMessage: "Поле [Отмена бонуса] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((!this.state.bonus_withdraw_type_code) || (this.state.bonus_withdraw_type_title.length === 0)) {
            this.setState({
                bonus_withdraw_type_rules: { isError: true, errorMessage: "Поле [Поведение при снятии] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.bonus_permission_type_code) || (this.state.bonus_permission_type_title.length === 0)) {
            this.setState({
                bonus_permission_type_rules: { isError: true, errorMessage: "Поле [Верификация пользователя] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.props.record.is_freespins) {
            if ((!this.state.freespin_gameset_id) || (this.state.freespin_gameset_title.length === 0)) {
                this.setState({
                    freespin_gameset_rules: { isError: true, errorMessage: "Поле [Набор игр] не заполнено!" },
                    tabKey: this.key_freespins
                });
                return false;
            }
            if (this.state.is_freespin_pre_selected_game) {
                if ((!this.state.freespin_game_id) || (this.state.freespin_game_title.length === 0)) {
                    this.setState({
                        freespin_game_rules: { isError: true, errorMessage: "Поле [игра] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if ((!this.state.freespin_count) || (this.state.freespin_count <= 0) || (this.state.freespin_count > 9999)) {
                this.setState({
                    freespin_gameset_rules: { isError: true, errorMessage: "Поле [кол-во фриспинов] не заполнено!" },
                    tabKey: this.key_freespins
                });
                return false;
            }
            if (this.state.is_freespin_pre_selected_bet) {
                if ((!this.state.freespin_bet) || (this.state.freespin_bet <= 0)) {
                    this.setState({
                        freespin_bet_rules: { isError: true, errorMessage: "Поле [ставка] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_freespin_pre_selected_denomination) {
                if ((!this.state.freespin_denomination) || (this.state.freespin_denomination <= 0)) {
                    this.setState({
                        freespin_denomination_rules: { isError: true, errorMessage: "Поле [деноминация] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_freespin_pre_selected_multiplier) {
                if ((!this.state.freespin_multiplier) || (this.state.freespin_multiplier <= 0)) {
                    this.setState({
                        freespin_multiplier_rules: { isError: true, errorMessage: "Поле [множитель] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_freespin_pre_selected_lines) {
                if (this.state.freespin_lines < 0) {
                    this.setState({
                        freespin_lines_rules: { isError: true, errorMessage: "Поле [линии] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
        }
        if (this.state.is_bonus_get_wager_and_amount_from_level) {
            if ((this.state.bonus_wager_and_amount_level_source_type_code <= 0) || (this.state.bonus_wager_and_amount_level_source_type_title.length == 0)) {
                this.setState({
                    bonus_wager_and_amount_level_source_type_rules: { isError: true, errorMessage: "Поле [тип источника уровня ] не заполнено!" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if (this.state.is_custom_gws_zone) {
            if ((!this.state.custom_gws_zone_id) || (this.state.custom_gws_zone_title.length === 0)) {
                this.setState({
                    custom_gws_zone_rules: { isError: true, errorMessage: "Поле зона игрового провайдера не заполнено!" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if (this.state.is_active_bonus_has_expiration) {
            if ((!this.state.bonus_expiration_action_code) || (this.state.bonus_expiration_action_title.length === 0)) {
                this.setState({
                    bonus_expiration_action_rules: { isError: true, errorMessage: "Поле действие при завершении бонуса не заполнено!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        return true;
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                player_bonus_id: this.props.record.key,
                bonus_amount_value: this.state.bonus_amount_value,
                bonus_min_balance_to_activate: this.state.bonus_min_balance_to_activate,
                is_bonus_req_min_balance_to_activate: this.state.is_bonus_req_min_balance_to_activate,
                is_bonus_has_up_to_withdraw_amount_limit: this.state.is_bonus_has_up_to_withdraw_amount_limit,
                bonus_up_to_withdraw_amount_limit: this.state.bonus_up_to_withdraw_amount_limit,
                is_bonus_has_up_to_bonus_amount_limit: this.state.is_bonus_has_up_to_bonus_amount_limit,
                bonus_up_to_bonus_amount_limit: this.state.bonus_up_to_bonus_amount_limit,
                is_bonus_has_up_to_bet_amount_limit: this.state.is_bonus_has_up_to_bet_amount_limit,
                bonus_up_to_bet_amount_limit: this.state.bonus_up_to_bet_amount_limit,
                bonus_wager_multiplier: this.state.bonus_wager_multiplier,
                bonus_debit_type_code: this.state.bonus_debit_type_code,
                bonus_cancel_type_code: this.state.bonus_cancel_type_code,
                bonus_activation_type_code: this.state.bonus_permission_type_code,
                bonus_withdrawal_type_code: this.state.bonus_withdraw_type_code,
                is_bonus_deposit_allowed: this.state.is_deposit_allowed,
                on_deposit_add_percent_value_on_bonus_balance: this.state.on_deposit_add_bonus_balance_percent,
                on_deposit_add_percent_value_on_bonus_wagering: this.state.on_deposit_add_bonus_wagering_percent,
                is_bonus_auto_complete: this.state.is_bonus_auto_complete,
                freespin_gameset_id: this.state.freespin_gameset_id,
                is_freespin_pre_selected_game: this.state.is_freespin_pre_selected_game,
                freespin_game_id: this.state.freespin_game_id,
                freespin_count: this.state.freespin_count,
                is_freespin_pre_selected_bet: this.state.is_freespin_pre_selected_bet,
                freespin_bet: this.state.freespin_bet,
                is_freespin_pre_selected_denomination: this.state.is_freespin_pre_selected_denomination,
                freespin_denomination: this.state.freespin_denomination,
                is_freespin_pre_selected_multiplier: this.state.is_freespin_pre_selected_multiplier,
                freespin_multiplier: this.state.freespin_multiplier,
                is_freespin_pre_selected_lines: this.state.is_freespin_pre_selected_lines,
                freespin_lines: this.state.freespin_lines,
                bonus_wager_and_amount_level_source_type_code: this.state.bonus_wager_and_amount_level_source_type_code,
                is_bonus_get_wager_and_amount_from_level: this.state.is_bonus_get_wager_and_amount_from_level,
                custom_gws_zone_id: this.state.custom_gws_zone_id,
                is_custom_gws_zone: this.state.is_custom_gws_zone,
                is_override_gws_player_zone: this.state.is_override_gws_player_zone,
                is_active_bonus_has_expiration: this.state.is_active_bonus_has_expiration,
                bonus_expiration_action_code: this.state.bonus_expiration_action_code,
                active_bonus_expiration_ttl_hours: this.state.active_bonus_expiration_ttl_hours,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки бездепозитного бонуса с вейджером изменены!");
            });
        }
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getFormTitle = function () {
        return "Изменить настройки бездепозитного бонуса с вейджером";
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Отмена бонуса", placeholder: "Выберите действие при отмене бонуса" }, value: { key: this.state.bonus_cancel_type_code, value: this.state.bonus_cancel_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_cancel_type_code: newVal.key,
                        bonus_cancel_type_title: newVal.value,
                        bonus_cancel_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_cancel_types, required: true, rules: this.state.bonus_cancel_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Списание ставки", placeholder: "Выберите тип списания ставки" }, value: { key: this.state.bonus_debit_type_code, value: this.state.bonus_debit_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_debit_type_code: newVal.key,
                        bonus_debit_type_title: newVal.value,
                        bonus_debit_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_debit_types, required: true, rules: this.state.bonus_debit_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешать пополнение бонуса", value: this.state.is_deposit_allowed, onChecked: function (checked) { _this.setState({ is_deposit_allowed: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "% суммы в баланс:", placeholder: "Введите какой % от депозита зачислится на бонусный баланс" }, values: { max: 1000, min: 0, value: this.state.on_deposit_add_bonus_balance_percent }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_deposit_add_bonus_balance_percent: newVal,
                        on_deposit_add_bonus_balance_percent_rules: { isError: false }
                    });
                }, disabled: !this.state.is_deposit_allowed, rules: this.state.on_deposit_add_bonus_balance_percent_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "% суммы в отыгрыш:", placeholder: "Введите какой % от депозита зачислится в отыгрыш" }, values: { max: 1000, min: 0, value: this.state.on_deposit_add_bonus_wagering_percent }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_deposit_add_bonus_wagering_percent: newVal,
                        on_deposit_add_bonus_wagering_percent_rules: { isError: false }
                    });
                }, disabled: !this.state.is_deposit_allowed, rules: this.state.on_deposit_add_bonus_wagering_percent_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Активный бонус будет иметь срок действия", value: this.state.is_active_bonus_has_expiration, onChecked: function (checked) { _this.setState({ is_active_bonus_has_expiration: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "При истечении бонуса:", placeholder: "Выберите действие при истечении бонуса" }, value: { key: this.state.bonus_expiration_action_code, value: this.state.bonus_expiration_action_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_expiration_action_code: newVal.key,
                        bonus_expiration_action_title: newVal.value,
                        bonus_expiration_action_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_cancel_types, required: true, rules: this.state.bonus_expiration_action_rules, disabled: !this.state.is_active_bonus_has_expiration }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Срок жизни бонуса, час:", placeholder: "Введите срок жизни бонуса в часах" }, values: { max: 999999, min: 1, value: this.state.active_bonus_expiration_ttl_hours }, onValueChanged: function (newVal) {
                    _this.setState({
                        active_bonus_expiration_ttl_hours: newVal,
                    });
                }, disabled: !this.state.is_active_bonus_has_expiration }),
            this.getActionButtons()));
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Брать сумму и значение бонуса из уровня", value: this.state.is_bonus_get_wager_and_amount_from_level, onChecked: function (checked) { _this.setState({ is_bonus_get_wager_and_amount_from_level: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Источник в уровне", placeholder: "Выберите источник в уровне" }, value: { key: this.state.bonus_wager_and_amount_level_source_type_code, value: this.state.bonus_wager_and_amount_level_source_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_wager_and_amount_level_source_type_code: newVal.key,
                        bonus_wager_and_amount_level_source_type_title: newVal.value,
                        bonus_wager_and_amount_level_source_type_rules: { isError: false }
                    });
                }, items: this.state.avail_level_src, required: this.state.is_bonus_get_wager_and_amount_from_level, rules: this.state.bonus_debit_type_rules, disabled: !this.state.is_bonus_get_wager_and_amount_from_level }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма бонуса:", placeholder: "Введите сумму бонуса" }, values: { max: 999999, min: 1, value: this.state.bonus_amount_value }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_amount_value: newVal
                    });
                }, disabled: this.state.is_bonus_get_wager_and_amount_from_level }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер вейджера:", placeholder: "Введите размер вейджера" }, values: { max: 9999, min: 1, value: this.state.bonus_wager_multiplier }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_wager_multiplier: newVal
                    });
                }, disabled: this.state.is_bonus_get_wager_and_amount_from_level }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать минимальный баланс для активации", value: this.state.is_bonus_req_min_balance_to_activate, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_req_min_balance_to_activate: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Минимальный баланс:", placeholder: "Введите минимальный баланс для активации" }, values: { max: 999999999, min: 1, value: this.state.bonus_min_balance_to_activate }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_min_balance_to_activate: newVal
                    });
                }, disabled: !this.state.is_bonus_req_min_balance_to_activate }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Поведение при снятии", placeholder: "Выберите поведение при снятии с баланса" }, value: { key: this.state.bonus_withdraw_type_code, value: this.state.bonus_withdraw_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_withdraw_type_code: newVal.key,
                        bonus_withdraw_type_title: newVal.value,
                        bonus_withdraw_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_withdraw_types, required: true, rules: this.state.bonus_withdraw_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Требование к верификации", placeholder: "Выберите поведение при активации" }, value: { key: this.state.bonus_permission_type_code, value: this.state.bonus_permission_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_permission_type_code: newVal.key,
                        bonus_permission_type_title: newVal.value,
                        bonus_permission_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_permission_types, required: true, rules: this.state.bonus_permission_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать отдельную зону проавйдера", value: this.state.is_custom_gws_zone, onChecked: function (checked) { _this.setState({ is_custom_gws_zone: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Зона провайдера", placeholder: "Выберите зону провайдера" }, value: { key: this.state.custom_gws_zone_id, value: this.state.custom_gws_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        custom_gws_zone_id: newVal.key,
                        custom_gws_zone_title: newVal.value,
                        custom_gws_zone_rules: { isError: false }
                    });
                }, items: this.state.avail_gws_zones, required: this.state.is_custom_gws_zone, disabled: !this.state.is_custom_gws_zone, rules: this.state.custom_gws_zone_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Переопределять зону игрока (если есть)", value: this.state.is_override_gws_player_zone, onChecked: function (checked) { _this.setState({ is_override_gws_player_zone: checked }); }, disabled: !this.state.is_custom_gws_zone }),
            this.getActionButtons()));
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getRestrictionEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму снятия при отыгрыше", value: this.state.is_bonus_has_up_to_withdraw_amount_limit, onChecked: function (checked) { _this.setState({ is_bonus_has_up_to_withdraw_amount_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма снятия:", placeholder: "Введите максимальную сумму снятия" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_withdraw_amount_limit }, onValueChanged: function (newVal) { _this.setState({ bonus_up_to_withdraw_amount_limit: newVal }); }, disabled: !this.state.is_bonus_has_up_to_withdraw_amount_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму бонуса", value: this.state.is_bonus_has_up_to_bonus_amount_limit, onChecked: function (checked) { _this.setState({ is_bonus_has_up_to_bonus_amount_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма бонуса:", placeholder: "Введите максимальную сумму бонуса" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_bonus_amount_limit }, onValueChanged: function (newVal) { _this.setState({ bonus_up_to_bonus_amount_limit: newVal }); }, disabled: !this.state.is_bonus_has_up_to_bonus_amount_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму ставки", value: this.state.is_bonus_has_up_to_bet_amount_limit, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_has_up_to_bet_amount_limit: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма ставки:", placeholder: "Введите максимальную сумму ставки" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_bet_amount_limit }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_up_to_bet_amount_limit: newVal
                    });
                }, disabled: !this.state.is_bonus_has_up_to_bet_amount_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Автоматически завершать бонус", value: this.state.is_bonus_auto_complete, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_auto_complete: checked
                    });
                } }),
            this.getActionButtons()));
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getFreeSpinEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Набор игр", placeholder: "Выберите набор игр" }, value: { key: this.state.freespin_gameset_id, value: this.state.freespin_gameset_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_gameset_id: newVal.key,
                        freespin_gameset_title: newVal.value,
                        freespin_gameset_rules: { isError: false },
                        freespin_game_id: 0,
                        freespin_game_title: "",
                        freespin_game_rules: { isError: false }
                    }, function () {
                        _this.props.listGameSetGames.LoadDataByGameSetId(_this.state.freespin_gameset_id);
                    });
                }, items: this.state.avail_gamesets, required: true, rules: this.state.freespin_gameset_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заранее определенная игра", value: this.state.is_freespin_pre_selected_game, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_game: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра", placeholder: "Выберите игру" }, value: { key: this.state.freespin_game_id, value: this.state.freespin_game_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_game_id: newVal.key,
                        freespin_game_title: newVal.value,
                        freespin_game_rules: { isError: false }
                    });
                }, items: this.state.avail_gameset_games, required: this.state.is_freespin_pre_selected_game, rules: this.state.freespin_game_rules, disabled: !this.state.is_freespin_pre_selected_game }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во фриспинов:", placeholder: "Введите количество фриспинов" }, values: { max: 9999, min: 1, value: this.state.freespin_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_count: newVal,
                        freespin_count_rules: { isError: false }
                    });
                }, required: true, rules: this.state.freespin_count_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенная ставка", value: this.state.is_freespin_pre_selected_bet, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_bet: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер ставки:", placeholder: "Введите размер ставки" }, values: { max: 9999, min: 0.01, value: this.state.freespin_bet }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_bet: newVal,
                        freespin_bet_rules: { isError: false }
                    });
                }, precision: 2, disabled: !this.state.is_freespin_pre_selected_bet, rules: this.state.freespin_bet_rules, required: this.state.is_freespin_pre_selected_bet }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенная деноминация", value: this.state.is_freespin_pre_selected_denomination, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_denomination: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер деноминации:", placeholder: "Введите размер деноминации" }, values: { max: 9999, min: 0.01, value: this.state.freespin_denomination }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_denomination: newVal,
                        freespin_denomination_rules: { isError: false }
                    });
                }, precision: 2, disabled: !this.state.is_freespin_pre_selected_denomination, rules: this.state.freespin_denomination_rules, required: this.state.is_freespin_pre_selected_denomination }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенный множитель", value: this.state.is_freespin_pre_selected_multiplier, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_multiplier: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер множителя:", placeholder: "Введите размер множителя" }, values: { max: 9999, min: 1, value: this.state.freespin_multiplier }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_multiplier: newVal,
                        freespin_multiplier_rules: { isError: false }
                    });
                }, disabled: !this.state.is_freespin_pre_selected_multiplier, rules: this.state.freespin_multiplier_rules, required: this.state.is_freespin_pre_selected_multiplier }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенное кол-во линий", value: this.state.is_freespin_pre_selected_lines, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_lines: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во линий:", placeholder: "Введите количество линий" }, values: { max: 9999, min: 1, value: this.state.freespin_lines }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_lines: newVal,
                        freespin_lines_rules: { isError: false }
                    });
                }, disabled: !this.state.is_freespin_pre_selected_lines, rules: this.state.freespin_lines_rules, required: this.state.is_freespin_pre_selected_lines }),
            this.getActionButtons()));
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        if (this.state.tabKey == this.key_restrictions) {
            return this.getRestrictionEditContent();
        }
        if (this.state.tabKey == this.key_freespins) {
            return this.getFreeSpinEditContent();
        }
        return null;
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.getTabsArray = function () {
        var _ret = [];
        _ret.push({ key: this.key_main, tab: "Основные" });
        _ret.push({ key: this.key_additional, tab: "Дополнительно" });
        _ret.push({ key: this.key_restrictions, tab: "Ограничения" });
        if (this.props.record.is_freespins) {
            _ret.push({ key: this.key_freespins, tab: "Фриспины" });
        }
        return _ret;
    };
    PlayerBonusWagerNoDepCfgEdit.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 810, activeTabKey: this.state.tabKey, tabs: this.getTabsArray(), onTabChange: function (key) {
                _this.setState({
                    tabKey: key
                });
            } }, this.getContent()));
    };
    return PlayerBonusWagerNoDepCfgEdit;
}(React.Component));
exports.default = PlayerBonusWagerNoDepCfgEdit;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/bonuses/wager_no_dep/PlayerBonusWagerNoDepCfgEdit.tsx
// module id = 1935
// module chunks = 0